import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faFileLines, faXmark } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { formatDateLong } from 'ns_libs/formatter';
import './FileCard.scss';
import { ITemporaryUploadedFile } from 'views/ProFormaUpload/types';

interface IFileCardProps {
    file: Pick<ITemporaryUploadedFile, 'id' | 'name'> & { createdAt?: Date };
    isSelected?: boolean;
    onDelete?: () => void;
    onClick?: (isSelected: boolean) => void;
}

const FileCard = ({
    file, isSelected, onDelete, onClick,
}: IFileCardProps) => (
    <div
        role="button"
        tabIndex={0}
        onClick={() => onClick?.(!isSelected)}
        onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick?.(!isSelected);
            }
        }}
        className={classNames(
            'FileCard d-flex align-items-center p-2 rounded',
            { 'FileCard--selected': isSelected },
        )}
    >
        <FontAwesomeIcon icon={faFileLines} className="FileCard__icon" size="lg" />
        <div className="FileCard__content">
            <div className="FileCard__filename" title={file.name}>{file.name}</div>
            <div className="FileCard__date">
                {formatDateLong(file.createdAt ?? new Date(), { month: 'long', day: 'numeric', year: 'numeric' })}
            </div>
        </div>
        {onDelete && (
            <FontAwesomeIcon
                icon={faXmark}
                className="cursor--pointer"
                onClick={e => {
                    e.stopPropagation();
                    onDelete();
                }}
            />
        )}
        {isSelected && (
            <FontAwesomeIcon icon={faCheck} size="lg" className="text-primary" />
        )}
    </div>
);

export default FileCard;
